export default `/* Ids Layout Flex Item Component */
:host([align-self=auto]),
.ids-layout-flex-item-align-self-auto {
  align-self: auto;
}

:host([align-self=baseline]),
.ids-layout-flex-item-align-self-baseline {
  align-self: baseline;
}

:host([align-self=center]),
.ids-layout-flex-item-align-self-center {
  align-self: center;
}

:host([align-self=stretch]),
.ids-layout-flex-item-align-self-stretch {
  align-self: stretch;
}

:host([align-self=flex-start]),
.ids-layout-flex-item-align-self-flex-start {
  align-self: flex-start;
}

:host([align-self=flex-end]),
.ids-layout-flex-item-align-self-flex-end {
  align-self: flex-end;
}

:host([grow="0"]),
.ids-layout-flex-item-grow-0 {
  flex-grow: 0;
}

:host([grow="1"]),
.ids-layout-flex-item-grow-1 {
  flex-grow: 1;
}

:host([grow="1"]) {
  min-height: 0;
}

:host([shrink="0"]),
.ids-layout-flex-item-shrink-0 {
  flex-shrink: 0;
}

:host([shrink="1"]),
.ids-layout-flex-item-shrink-1 {
  flex-shrink: 1;
}

:host([flex="1"]),
.ids-layout-flex-item-flex-1 {
  flex: 1;
}

:host([flex="2"]),
.ids-layout-flex-item-flex-2 {
  flex: 2;
}

:host([flex="3"]),
.ids-layout-flex-item-flex-3 {
  flex: 3;
}

:host([flex="4"]),
.ids-layout-flex-item-flex-4 {
  flex: 4;
}

:host([flex="5"]),
.ids-layout-flex-item-flex-5 {
  flex: 5;
}

:host([flex="6"]),
.ids-layout-flex-item-flex-6 {
  flex: 6;
}

:host([flex="7"]),
.ids-layout-flex-item-flex-7 {
  flex: 7;
}

:host([flex="8"]),
.ids-layout-flex-item-flex-8 {
  flex: 8;
}

:host([flex="9"]),
.ids-layout-flex-item-flex-9 {
  flex: 9;
}

:host([flex="10"]),
.ids-layout-flex-item-flex-10 {
  flex: 10;
}

:host([flex="11"]),
.ids-layout-flex-item-flex-11 {
  flex: 11;
}

:host([flex="12"]),
.ids-layout-flex-item-flex-12 {
  flex: 12;
}

:host([flex="13"]),
.ids-layout-flex-item-flex-13 {
  flex: 13;
}

:host([flex="14"]),
.ids-layout-flex-item-flex-14 {
  flex: 14;
}

:host([flex="15"]),
.ids-layout-flex-item-flex-15 {
  flex: 15;
}

:host([flex="16"]),
.ids-layout-flex-item-flex-16 {
  flex: 16;
}

:host([flex="17"]),
.ids-layout-flex-item-flex-17 {
  flex: 17;
}

:host([flex="18"]),
.ids-layout-flex-item-flex-18 {
  flex: 18;
}

:host([flex="19"]),
.ids-layout-flex-item-flex-19 {
  flex: 19;
}

:host([flex="20"]),
.ids-layout-flex-item-flex-20 {
  flex: 20;
}

:host([flex="21"]),
.ids-layout-flex-item-flex-21 {
  flex: 21;
}

:host([flex="22"]),
.ids-layout-flex-item-flex-22 {
  flex: 22;
}

:host([flex="23"]),
.ids-layout-flex-item-flex-23 {
  flex: 23;
}

:host([flex="24"]),
.ids-layout-flex-item-flex-24 {
  flex: 24;
}

:host([overflow=auto]),
.ids-layout-flex-item-overflow-auto {
  overflow: auto;
}

:host([overflow=hidden]),
.ids-layout-flex-item-overflow-hidden {
  overflow: hidden;
}

:host([overflow=visible]),
.ids-layout-flex-item-overflow-visible {
  overflow: visible;
}

:host([overflow=scroll]),
.ids-layout-flex-item-overflow-scroll {
  overflow: scroll;
}

:host(.has-container-grid[grow="0"][shrink="0"]),
.ids-layout-flex-item.has-container-grid.ids-layout-flex-item-grow-0.ids-layout-flex-item-shrink-0 {
  width: 100%;
}

::slotted(ids-input[size=full]) {
  display: inline-block;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
